import CryptoJS from "crypto-js";
import {
    resolvePayloadAuthenticationKey,
    resolvePayloadEncryptionKey,
} from "../envConfig/config";

// The AES-256 key and the HMAC key are read from .env when first used (see envConfig/config.js).
const keyFor = (resolveKey, envName) => {
    const value = resolveKey();
    if (!value) throw new Error(`${envName} is not set in .env`);
    return CryptoJS.enc.Base64.parse(value);
};
const encryptionKey = () => keyFor(resolvePayloadEncryptionKey, "REACT_APP_ENCRYPTION_KEY");
const authenticationKey = () =>
    keyFor(resolvePayloadAuthenticationKey, "REACT_APP_<NETWORK>_AUTHENTICATION_KEY");

export const encryptData = (data) => {
    const ENCRYPTION_KEY = encryptionKey();
    const AUTHENTICATION_KEY = authenticationKey();

    // Generate Initialization Vector (IV)
    const iv = CryptoJS.lib.WordArray.random(16);

    // Convert payload to string
    const payloadString = JSON.stringify(data);

    // Encrypt the payload
    const encrypted = CryptoJS.AES.encrypt(payloadString, ENCRYPTION_KEY, {
        iv: iv,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7,
    });
    const encryptedPayload = encrypted.toString();

    // Calculate HMAC for the encrypted payload
    const hmac = CryptoJS.HmacSHA256(encryptedPayload, AUTHENTICATION_KEY).toString(CryptoJS.enc.Base64);

    // Return the encrypted payload and headers
    return {
        encryptedPayload,
        headers: {
            "x-encryption-iv": iv.toString(CryptoJS.enc.Base64),
            "x-authentication-mac": hmac,
        },
    };
};

export const decryptData = (encryptedPayload, iv, receivedHmac) => {
    try {
        // Verify HMAC
        const calculatedHmac = CryptoJS.HmacSHA256(encryptedPayload, authenticationKey()).toString(CryptoJS.enc.Base64);

        if (calculatedHmac !== receivedHmac) {
            return {
                statusCode: 403,
                message: "Invalid HMAC signature",
            };
        }

        // Decrypt the payload
        const decryptedBytes = CryptoJS.AES.decrypt(encryptedPayload, encryptionKey(), {
            iv: iv,
            mode: CryptoJS.mode.CBC,
            padding: CryptoJS.pad.Pkcs7,
        });
        const decryptedData = decryptedBytes.toString(CryptoJS.enc.Utf8);

        // Check if decryptedData is not an empty string
        if (!decryptedData) {
            return {
                statusCode: 401,
                message: "Authentication error",
            };
        }
        return JSON.parse(decryptedData); // Parse the decrypted data as JSON
    } catch (err) {
        console.error("Error decoding the response:", err);
        return {
            statusCode: 401,
            message: "Authentication error",
        };
    }
};
